@let subpageKey = subpage();

<app-pan-card [header]="" [isPageContainer]="true" [pageContainerSize]="'xl'">
  <nav class="flex p-2 bg-neutral-100 border border-[#e5e7eb] rounded-lg mb-4" data-testid="bl-nav-breadcrumb">
    <ol class="inline-flex items-center space-x-1 md:space-x-2">
      <li class="inline-flex items-center gap-2">
        <mat-icon>security</mat-icon>
        Manage
      </li>

      @let currentRoot = currentRootPage();
      <li class="inline-flex items-center gap-2">
        &raquo;
        <a class="text-primary hover:underline" [routerLink]="['/home', 'manage', currentRoot.key]" ]>{{ currentRoot.label }}</a>

        <app-pan-button size="sm" color="default" [matMenuTriggerFor]="menu">
          <mat-menu #menu="matMenu">
            @for (root of allRootPages; track $index) {
              <a
                class="text-primary hover:underline"
                mat-menu-item
                [routerLink]="['/home', 'manage', root.key]"
                [disabled]="currentRoot.key === root.key"
              >
                {{ root.label }}
              </a>
            }
          </mat-menu>
        </app-pan-button>
      </li>

      @if (
        isSpecificBranchManagement() || isGeneralLocationManagement() || isSpecificLocationManagement() || isSpecificCameraManagement()
      ) {
        <li class="inline-flex items-center gap-2">
          &raquo;
          <a
            class="text-primary hover:underline"
            data-testid="bl-nav-breadcrumb-branch"
            [routerLink]="['/home', 'manage', 'branch', branchId()]"
          >
            @if (selectedBranch(); as branch) {
              {{ branch.name }}
              @if (branch.keystore?.suspend_access) {
                [Access Suspended]
              }
            } @else {
              <app-pan-spinner></app-pan-spinner>
            }
          </a>
        </li>
      }

      @if (isGeneralLocationManagement() || isSpecificLocationManagement() || isSpecificCameraManagement()) {
        <li class="inline-flex items-center gap-2">
          &raquo;
          <a class="text-primary hover:underline" [routerLink]="['/home', 'manage', 'branch', branchId(), 'location']">Locations</a>
        </li>
      }

      @if (isSpecificLocationManagement() || isSpecificCameraManagement()) {
        <li class="inline-flex items-center gap-2">
          &raquo;
          <a class="text-primary hover:underline" [routerLink]="['/home', 'manage', 'branch', branchId(), 'location', locationId()]">
            @if (selectedLocation(); as location) {
              {{ location.name }}
            } @else {
              <app-pan-spinner></app-pan-spinner>
            }
          </a>
        </li>
      }

      @if (isSpecificCameraManagement()) {
        <li class="inline-flex items-center gap-2">
          &raquo;
          <a class="text-primary">Cameras</a>
        </li>
        <li class="inline-flex items-center gap-2">
          &raquo;
          <a
            class="text-primary hover:underline"
            [routerLink]="['/home', 'manage', 'branch', branchId(), 'location', locationId(), 'camera', locationCameraId()]"
          >
            @if (selectedLocationCamera(); as c) {
              {{ c.camera_name }}
            } @else {
              <app-pan-spinner></app-pan-spinner>
            }
          </a>
        </li>
      }

      @if (branchId() && currentSubpageComponentName()) {
        <li class="inline-flex items-center gap-2">
          &raquo;
          <span class="text-primary">{{ currentSubpageComponentName() }}</span>
        </li>
      }

      @if (isLocationGroupSpecificManagement()) {
        <li class="inline-flex items-center gap-2">
          &raquo;

          @if (selectedLocationGroup(); as locationGroup) {
            <a class="text-primary hover:underline" [routerLink]="['/home', 'manage', 'locationgroup', locationGroup.id]">
              {{ locationGroup.name }}
            </a>
          } @else {
            <app-pan-spinner></app-pan-spinner>
          }
        </li>
      }
    </ol>
  </nav>

  @if (!subpageKey && isGeneralBranchManagement()) {
    <app-bl-management-branches
      [(branches)]="allBranches"
      [isLoading]="isLoadingBranches()"
      (selectBranch)="selectBranch($event)"
    ></app-bl-management-branches>
  }

  @if (!subpageKey && isSpecificBranchManagement()) {
    @if (selectedBranch()) {
      <app-bl-management-branch [(branch)]="selectedBranch" (loadSubpage)="subpage.set($event)"></app-bl-management-branch>
    } @else {
      <app-pan-blank-slate> <app-pan-spinner></app-pan-spinner> Loading branch... </app-pan-blank-slate>
    }
  }

  @if (!subpageKey && isGeneralLocationManagement()) {
    <app-bl-management-locations
      [branches]="allBranches()"
      [branchId]="+branchId()"
      [isLoading]="isLoadingLocations()"
      [(locations)]="allLocationsForBranch"
      [(archivedLocations)]="allArchivedLocationsForBranch"
      (reloadLocations)="refreshLocations()"
      (selectLocation)="selectLocation($event)"
      (removeLocation)="removeLocation($event)"
    ></app-bl-management-locations>
  }

  @if (!subpageKey && isSpecificLocationManagement()) {
    <app-bl-management-location
      [branchId]="+branchId()"
      [locationId]="+locationId()"
      [isChild]="true"
      (selectLocationCamera)="selectLocationCamera($event)"
    ></app-bl-management-location>
  }

  @if (!subpageKey && isSpecificCameraManagement()) {
    <app-camera-edit [locationId]="+locationId()" [locationCameraId]="locationCameraId()"></app-camera-edit>
  }

  @if (branchId() && subpageKey) {
    <ng-container *ngComponentOutlet="currentSubpageComponent(); inputs: subpageComponentInputs()" />
  }

  @if (isLocationGroupGeneralManagement() && !isLocationGroupSpecificManagement()) {
    <app-bl-management-locationgroups
      [(locationGroups)]="allLocationGroups"
      [isLoading]="isLoadingLocationGroups()"
      (selectLocationGroup)="selectLocationGroup($event)"
    ></app-bl-management-locationgroups>
  }

  @if (isLocationGroupSpecificManagement() && selectedLocationGroup()) {
    <app-bl-management-locationgroup [locationGroup]="selectedLocationGroup()"></app-bl-management-locationgroup>
  }
</app-pan-card>
